import { render, staticRenderFns } from "./Installer.vue?vue&type=template&id=700c34c6"
import script from "./Installer.vue?vue&type=script&lang=ts"
export * from "./Installer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports